import moment from 'moment';

export const APItoExcel = (data) => {
    const formatted = data.reduce((r,i,idx) => {
        r.push({
            no:idx+1,
            reference_id:i.referenceId, 
            amount:i.amount,
            currency:i.currency, 
            description:i.description, 
            payment_category:i.paymentCategory, 
            payment_method:i.paymentMethod, 
            type:i.type,
            status:i.status,
            created_at:moment(i.createdAt).format("YYYY-MM-DD HH:mm:ss"), 
            created_date:moment(i.createdAt).format("YYYY-MM-DD"), 
            created_time:moment(i.createdAt).format("HH:mm:ss")
        });
        return r
    },[])
    return formatted;
}  